{
  "required": {
    "default": "Este campo é obrigatório",
    "email": "Email é obrigatório",
    "password": "Senha é obrigatória",
    "name": "Nome é obrigatório",
    "firstName": "Nome é obrigatório",
    "lastName": "Sobrenome é obrigatório",
    "phone": "Telefone é obrigatório"
  },
  "format": {
    "email": "Por favor, insira um email válido",
    "phone": "Por favor, insira um telefone válido",
    "url": "Por favor, insira uma URL válida",
    "date": "Por favor, insira uma data válida",
    "number": "Por favor, insira um número válido",
    "integer": "Por favor, insira um número inteiro"
  },
  "length": {
    "min": "Deve ter pelo menos {{min}} caracteres",
    "max": "Deve ter no máximo {{max}} caracteres",
    "exact": "Deve ter exatamente {{length}} caracteres",
    "between": "Deve ter entre {{min}} e {{max}} caracteres"
  },
  "password": {
    "min": "A senha deve ter pelo menos 8 caracteres",
    "uppercase": "A senha deve conter pelo menos uma letra maiúscula",
    "lowercase": "A senha deve conter pelo menos uma letra minúscula",
    "number": "A senha deve conter pelo menos um número",
    "special": "A senha deve conter pelo menos um caractere especial",
    "match": "As senhas não coincidem",
    "weak": "Senha muito fraca",
    "common": "Esta senha é muito comum"
  },
  "range": {
    "min": "Deve ser pelo menos {{min}}",
    "max": "Deve ser no máximo {{max}}",
    "between": "Deve estar entre {{min}} e {{max}}"
  },
  "file": {
    "required": "Por favor, selecione um arquivo",
    "size": "O tamanho do arquivo deve ser menor que {{size}}",
    "type": "Tipo de arquivo inválido. Tipos permitidos: {{types}}",
    "count": "Você pode enviar no máximo {{count}} arquivos"
  },
  "custom": {
    "terms": "Você deve aceitar os termos e condições",
    "age": "Você deve ter pelo menos {{age}} anos",
    "unique": "Este {{field}} já está em uso",
    "exists": "Este {{field}} não existe",
    "expired": "Este {{field}} expirou",
    "invalid": "{{field}} inválido"
  }
}
